import React from 'react';
import classNames from 'classnames';

export interface ListViewProps<T> {
    /**
     * Css класс списка.
     */
    className?: string;

    /**
     * Список значений.
     */
    values: T[];

    /**
     * Компонент, который будет отображаться если список переданных значений пуст.
     */
    emptyListComponent?: React.ReactElement;

    /**
     * Рендерер элемента списка.
     *
     * @param value значение
     * @param index индекс в списке
     */
    children: (value: T, index: number) => React.ReactElement;
}

/**
 * Компонент для рендеринга списка значений.
 *
 * Отвечает за установку key для элементов списка.
 * Object[] data
 * itemRenderer
 * ListView()

 * Примеры использования:
 * ```
 * // Коллекция для отображения
 * Person[] persons = ...
 *
 * // Вариант 1: Рендерер элемента в теле компонента
 * <LisView values={persons}>
 *     {(person, index) => <Person key={uniqueKey}/>}
 * </ListView>
 *
 * // Вариант 2: Рендерер элемента передается через props
 * let itemRenderer = (person, index) => <Person key={uniqueKey}/>
 * <ListView values={persons} children={itemRenderer} />
 * ```
 *
 * css-класс: alfaListView
 *
 * @param props
 * @constructor
 */
export default class ListView<T = any> extends React.Component<
    ListViewProps<T>
> {
    static defaultProps = { emptyListComponent: <></> };

    render() {
        const className = classNames('alfaListView', this.props.className);
        const { values, emptyListComponent } = this.props;

        return (
            <div className={className}>
                {values && values.length > 0
                    ? values.map(this.props.children)
                    : emptyListComponent}
            </div>
        );
    }
}
